var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scheme-level-menu"},_vm._l((_vm.levelNodes),function(node){return _c('div',{key:node.id,staticClass:"scheme-level-node"},[(node.children && node.children.length)?_c('v-list-group',{attrs:{"value":true}},[_c('v-list-item-content',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-item-title',[_vm._v(_vm._s(node.title))])],1),_c('AssessBySkillMenu',{attrs:{"complete-only":_vm.completeOnly,"level-tree":node.children}})],1):_c('v-list-item-content',[_c('router-link',{attrs:{"to":{
          name: 'assess-by-skill-grades',
          params: {
            name: _vm.getNodeLinkName(node),
            groupId: _vm.$route.params.groupId,
            selectedNodeId: node.id,
            completeOnly: _vm.completeOnly,
          },
        }}},[_vm._v(" "+_vm._s(node.title)+" ")])],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }